import { useEffect, useRef, useState } from "react";
import { itx } from "../translationItx/itx";
import InstallationUtils from "./InstallationUtils";
import BridgeStatus from "../readback/BridgeStatus";

export default function CheckEstadaBridgeStatusOnLocalhost(props: { onChange: (running: boolean) => void }) {
  const { onChange } = props;

  const [knxGatewayIP, setKnxGatewayIP] = useState("");

  const [estadaBridgeIsRunning, setEstadaBridgeIsRunning] = useState<"yes" | "no" | "starting" | "error" | undefined>(
    undefined,
  ); // no itx

  const refStartServerButton = useRef<HTMLAnchorElement>(null);
  const startServerButtonClicked = useRef(false);

  const interval = useRef<any>(null);

  let socketServer = "";
  let isEmbbedded = false;

  if ((window as any).Host) {
    isEmbbedded = true;
  }
  if (isEmbbedded) {
    socketServer = "http://" + "localhost:8080";
  } else {
    socketServer = "http://" + localStorage.getItem("webSocketServer") || "";
  }

  // socketServer = "https://localhost:8443";
  socketServer = "localhost:8080";

  //
  // return
  //  ** undefined, if we dont get a response from the estadaBridge
  //  ** the IP-Address of the connected KNX/IP - Interface
  //     this maybe empty ("") if no Interface could be found
  //
  async function pingEstadaBridge(): Promise<string | undefined> {
    try {
      const url = "http://" + socketServer + "/test"; // no itx
      const response = await fetch(url);
      if (response.status == 200) {
        //
        // text should be the IP-Address of the PNX/IP Interface
        //
        return await response.text();
      }
    } catch (ex) {}

    return undefined;
  }

  async function searchBridge() {
    interval.current = setInterval(
      async () => {
        let x = await pingEstadaBridge();
        if (x) {
          setEstadaBridgeIsRunning("yes"); // no itx
          setKnxGatewayIP(x);

          onChange(true);
          state.estadaBridgeIsRunning = true;

          clearInterval(interval.current);
          interval.current = null;
        } else {
          state.estadaBridgeIsRunning = false;
          onChange(false);
        }
        state.justTiedToStartEstadaBridge = false;
      },
      2000,
      state.justTiedToStartEstadaBridge ? 3000 : 0,
    );
  }

  async function init() {
    if (!startServerButtonClicked.current) {
      startServerButtonClicked.current = true;
      refStartServerButton.current?.click();
    }
    searchBridge();
  }

  useEffect(() => {
    init();

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, []);

  switch (estadaBridgeIsRunning) {
    case "no":
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div>
            <a
              className="button"
              ref={refStartServerButton}
              style={{ textDecoration: "none" }}
              href="estada://Test" // no itx
              onClick={() => {
                searchBridge();
              }}
            >
              {itx("checkEstadaBridgeStatusOnLocalhost.srartEstadaBridge", "Start EstadaBridge on this computer")}
            </a>
          </div>
          <br />
          <div>
            {itx(
              "checkEstadaBridgeStatusOnLocalhost.needsEstadaBridge",
              `Estada needs additional software: "EstadaBridge"`,
            )}
            <br />
            {itx(
              "checkEstadaBridgeStatusOnLocalhost.runningToConnectKNXInterface",
              "running on this machine to connect to Your KNX-IP Interface.",
            )}
            <br />
            <br />
            {itx(
              "checkEstadaBridgeStatusOnLocalhost.not1installed",
              "If You not already installed EstadaBridge on this computer,",
            )}
            <br />
            {itx(
              "checkEstadaBridgeStatusOnLocalhost.downloadAndInstallFromHereT1",
              "please download and install it from T1 ",
              { T1: <a href="http:estada.de">{itx("checkEstadaBridgeStatusOnLocalhost.here", "here...")}</a> },
            )}
          </div>
        </div>
      );

    case "yes":
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div>{itx("checkEstadaBridgeStatusOnLocalhost.estadaBridgeRunning", "EstadaBridge is running")}</div>
          <div>
            {itx("checkEstadaBridgeStatusOnLocalhost.knxGateWayIP", "KNX Gateway-IP:")}
            {knxGatewayIP}
          </div>
        </div>
      );

    case "starting":
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div> {itx("panel.startEstadaBridge", "Start Estada Bridge")}</div>
          <div>
            {itx("checkEstadaBridgeStatusOnLocalhost.knxGateWayIP", "KNX Gateway-IP:")}
            {knxGatewayIP}
          </div>
        </div>
      );

    case "error":
      const errorTitle = state.knxStateText.value;
      return (
        <div style={{ display: "flex", flexDirection: "column", backgroundColor: "red" }}>
          <div>{itx("checkEstadaBridgeStatusOnLocalhost.estadaBridgeError", "EstadaBridge Error")}</div>
          <div>{errorTitle}</div>
        </div>
      );

    default:
      return (
        <div style={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
          {/* <div>{itx("checkEstadaBridgeStatusOnLocalhost.tryToConnectBridge", "Try to connect to EstadaBridge.")}</div>
          <div>{itx("checkEstadaBridgeStatusOnLocalhost.pleaseWait", "Please wait ....")}</div> */}
          <BridgeStatus autoConnect={true} />
          {/* <a
            style={{ marginLeft: "10px", textDecoration: "none" }}
            className="button"
            href="estada://Test"
            onClick={() => {
              setEstadaBridgeIsRunning("starting");
              setTimeout(() => {
                InstallationUtils.init();
                if (state.knxState.value == "error") {
                  setEstadaBridgeIsRunning("error");
                } else {
                  setEstadaBridgeIsRunning("yes");
                }
              }, 2000);
            }}
          >
            {itx("panel.startEstadaBridge", "Start Estada Bridge")}
          </a> */}
        </div>
      );
  }
}
